var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnAccount = function SvgEarnAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.412 6.916c1.245.304 3.76 1.71 3.863 4.905h1.059v1.81h-1.436c-.222.743-.986 2.331-2.255 2.74l.585.868-1.208 1.133-1.21-1.397H6.9l-1.398 1.284-1.266-1.114.87-.907-3.438-2.927v-2.399h1.795l.674-1.7-1.404-2.296zm-5.004 4.24h3.644V9.288H8.408zm1.364-9.53a3.09 3.09 0 0 1 2.81 4.373h-5.62a3.09 3.09 0 0 1 2.81-4.373M8.587 4.528l1.185 1.186 1.186-1.186-1.186-1.185z"
  })));
};
export default SvgEarnAccount;